export default {
    business: {
        tag: 'Tag',
        del_carrier: 'Delete',
        alarm_trigger: 'Alarm Triggering',
        import_carrier: 'Import Asset',
        carrier_status: 'Asset Status',
        alarm_status: 'Alarm',
        carrier_equipment: 'Asset Devices',
        carrier_detail: 'Asset Details',
        record_point: 'Time Point',
        traceable: 'Traceable',
        untraceable: 'Untraceable',
        curAbnormal: 'Abnormal or Not',
        carrried: 'Already Mounted',
        device: 'Device',
        isTraceable: 'Traceable',
        relation: 'Associated',
        unbind: 'Unbind',
        add_carrier: 'New',
        is_abnormal: 'Abnormal or Not'
    }
};
